import styled from 'styled-components';

export const Icon = styled.p`
  &:before {
    float: left;
    line-height: 76px;
    margin: 0 7px -12px 0;
    content: '';
    width: 62px;
    height: 82px;
  }
`;
export const Icon1 = Icon.extend`
  &:before {
    background-image: url('./img/svg/1.svg');
  }
`;
export const Icon2 = Icon.extend`
  &:before {
    background-image: url('./img/svg/2.svg');
  }
`;
export const Icon3 = Icon.extend`
  &:before {
    background-image: url('./img/svg/3.svg');
  }
`;
export const Icon4 = Icon.extend`
  &:before {
    background-image: url('./img/svg/4.svg');
  }
`;
export const Icon5 = Icon.extend`
  &:before {
    background-image: url('./img/svg/5.svg');
  }
`;
export const Icon6 = Icon.extend`
  &:before {
    background-image: url('./img/svg/6.svg');
  }
`;
export const Icon7 = Icon.extend`
  &:before {
    background-image: url('./img/svg/7.svg');
  }
`;



// WEBPACK FOOTER //
// ./src/styles/icons.js